import {
  Flag,
  GraduationCap,
  Headphones,
  MonitorPlay,
  UserCog,
  UserSearch,
} from "lucide-react";
import { teachingRoleStepCopy, teachingRoles } from "../../data/onboarding";
import { OnboardingFooter } from "./OnboardingFooter";
import { OnboardingOptionCard } from "./OnboardingOptionCard";
import { OnboardingShell } from "./OnboardingShell";

const ROLE_ICONS = {
  "school-teacher": GraduationCap,
  tutor: UserSearch,
  "academic-coordinator": UserCog,
  "independent-educator": MonitorPlay,
  "coaching-faculty": Flag,
  "teaching-assistant": Headphones,
};

export function TeachingRoleStep({ selectedRoleId, onSelectRole, onNext }) {
  return (
    <OnboardingShell>
      <div className="max-w-4xl">
        <h1 className="text-[32px] font-bold leading-tight text-[#1B1B2F] sm:text-[36px]">
          {teachingRoleStepCopy.title}
        </h1>
        <p className="mt-3 text-[15px] text-[#6B7280]">
          {teachingRoleStepCopy.subtitle}
        </p>

        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {teachingRoles.map((role) => {
            const Icon = ROLE_ICONS[role.id];
            return (
              <OnboardingOptionCard
                key={role.id}
                title={role.title}
                description={role.description}
                icon={Icon}
                selected={selectedRoleId === role.id}
                onClick={() => onSelectRole(role.id)}
              />
            );
          })}
        </div>

        <OnboardingFooter
          showBack={false}
          onNext={onNext}
          nextLabel={teachingRoleStepCopy.nextLabel}
          nextDisabled={!selectedRoleId}
        />
      </div>
    </OnboardingShell>
  );
}
